module.exports = __webpack_public_path__ + "img/kaf_yes.55596c01.png";